import React, { FC } from "react";
import type { PayallLifeHeroProps } from "@/types";
import { A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Image } from "../image";
import { TextCols } from "../text-cols";

export const PayallLifeHero: FC<PayallLifeHeroProps> = ({
  label,
  title,
  description,
  gallery,
}) => {
  return (
    <section className="payallLifeHero">
      <div className="wrapper">
        <TextCols
          headingLevel="h1"
          size="lg"
          label={label}
          content={{
            title,
            textCol1: description.textCol1,
            textCol2: description.textCol2,
          }}
        />
      </div>
      <div className="wrapper wrapper_lg">
        <Swiper
          modules={[A11y]}
          spaceBetween={12}
          slidesPerView={1.25}
          breakpoints={{
            1024: {
              slidesPerView: 2,
              spaceBetween: 56,
            },
          }}
          grabCursor
          className="payallLifeHero--swiper"
        >
          {gallery.map((slide, index) => {
            return (
              <SwiperSlide key={index} className="payallLifeHero--slide">
                {slide.file?.url && (
                  <Image
                    className="payallLifeHero--slide-image"
                    src={slide as any}
                    alt={slide.title}
                    draggable={false}
                    animateInView
                    options={{
                      sizes: {
                        exec: [
                          {
                            width: 692,
                            height: 682,
                          },
                        ],
                      },
                    }}
                  />
                )}
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
};
